import { useState } from 'react';
import { storage } from '../storage';

export const useUserId = () => {
  const [userId, setUserId] = useState(storage.userId());

  return [userId, setUserId] as const;
};

